import React from "react";
import img from "./christmas.png";
import "./default.scss";

class Christmas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <div className="bg" style={{ background: `#8f3b3c` }}>
        <div className="center">
          <img src={img} />
        </div>
        <div className="center text-xl py-2">
          We are closed until 8th of January, in the mean time, members only
          open mats every Wednesday and Friday from 15h to 19h.
          <br />
          Happy Holidays and a 2024 full of good vibes, healthy and victories 🎅
        </div>
        <br />
        <div className="center text-xl py-2">OOOOOSSSSSSS</div>
      </div>
    );
  }
}

export default Christmas;
